import React from 'react';

import PropTypes from 'prop-types';

import {
  VFButton,
  VFText,
  QuickActionMenu,
  Icon,
} from '@vfgroup-oneplatform/foundation/Components';
import {
  LightThemeColors,
  getThemeImages,
  useTheme,
} from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';

import styles from './PaymentError.Styles';
import { Dimensions, Platform } from 'react-native';
import ReactNativeModal from 'react-native-modal';
import { View } from 'native-base';

const PaymentError = ({
  isVisible,
  closeModal,
  onPressErrorAction,
  onPressErrorDefaultAction,
  error,
  currentCardData,
  images,
  ...props
}) => {
  const theme = useTheme() || LightThemeColors;
  const _images = images || getThemeImages(theme.name);

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <ReactNativeModal
        isVisible={isVisible}
        backdropOpacity={0.5}
        onSwipeComplete={closeModal}
        onBackdropPress={closeModal}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={{
          justifyContent: 'flex-end',
          margin: '0 !important',
          minWidth: 1920,
          maxWidth: 1920,
        }}
      >
        <View
          style={{
            height: '600px',
            minWidth: '600px',
            maxWidth: '600px',
            backgroundColor: theme.colors.quickActionGradientColors.secondary,
            margin: 'auto',
            padding: '20px',
            borderRadius: '7px',
          }}
          onStartShouldSetResponder={() => true}>
          <Icon type="image" name={_images.ic_warning_mid} size={48} style={styles.iconStyle} />
          {error && (
            <>
              <VFText
                testID={FrameworkTestKeys.PaymentErrorTitle}
                style={styles.title(theme)}
                i18nKey={error.title}
              />

              <VFText style={styles.description(theme)} i18nKey={error.description} />
            </>
          )}
          <VFButton
            title={error.actionTxt || ''}
            type="primary"
            onPress={() => {
              if (onPressErrorAction) {
                onPressErrorAction(error, closeModal, onPressErrorDefaultAction);
              } else {
                closeModal();
                error.isSavingError &&
                  setTimeout(() => {
                    onPressErrorDefaultAction(currentCardData);
                  }, 500);
              }
            }}
          />
        </View>
      </ReactNativeModal>
    )
  }
  return (
    <QuickActionMenu
      toggleModal={closeModal}
      isVisible={isVisible}
      closeModal={closeModal}
      containerStyle={styles.containerStyle(theme)}
      closeBtnStyle={styles.closeBtnStyle}
      title=""
      type={'secondary'}
    >
      <Icon type="image" name={_images.ic_warning_mid} size={48} style={styles.iconStyle} />
      {error && (
        <>
          <VFText
            testID={FrameworkTestKeys.PaymentErrorTitle}
            style={styles.title(theme)}
            i18nKey={error.title}
          />

          <VFText style={styles.description(theme)} i18nKey={error.description} />
        </>
      )}
      <VFButton
        title={error.actionTxt || ''}
        type="primary"
        onPress={() => {
          if (onPressErrorAction) {
            onPressErrorAction(error, closeModal, onPressErrorDefaultAction);
          } else {
            closeModal();
            error.isSavingError &&
              setTimeout(() => {
                onPressErrorDefaultAction(currentCardData);
              }, 500);
          }
        }}
      />
    </QuickActionMenu>
  );
};

PaymentError.propTypes = {
  onPressErrorAction: PropTypes.func,
  onPressErrorDefaultAction: PropTypes.func,
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
  error: PropTypes.object,
  currentCardData: PropTypes.object,
  images: PropTypes.object,
};
export default PaymentError;
